module.exports = __webpack_public_path__ + "img/tianjiaogame.9e42e970.png";